import {Equals, IsNotEmpty} from "class-validator";
import moment from "moment/moment";
import {Gender} from "../../enums/gender.enum";
import {UserSetting} from "../userSetting/userSetting.model";
import {IsBeforeDate} from "../../validators/isBeforeDate.validator";

class SignUpSSOProfile {

    @IsBeforeDate(moment().subtract(13,'years').toDate(), { message: "You must be over 13 years to make an account" })
    @IsNotEmpty({ message: "Please enter your date of birth" })
    dateOfBirth: Date;

    @IsNotEmpty({message: "Select an option"})
    gender: Gender;

    @Equals(true, { message: "" })
    termsAndConditions: boolean;

    allowMarketing: boolean;

    userSettings: UserSetting[];
}

export { SignUpSSOProfile }